import { Mark, MarkRaw } from './mark';
import { Penalty, PenaltyRaw } from './penalty';

export type LapRaw = Omit<Lap, 'marks' | 'penalty'> & { marks: MarkRaw[]; penalty: PenaltyRaw[] };

export class Lap {
  DSQ!: number;
  marks!: Mark[];
  time!: number;
  name!: string;
  hover!: boolean;
  penalty!: Penalty[];
  deltaLeader!: number;
  timeFromStart!: number;
  penaltyTime!: number;

  constructor(obj: LapRaw) {
    this.update(obj);
  }

  update(obj: LapRaw) {
    this.hover = false;
    this.DSQ = obj.DSQ;
    this.marks = [];
    this.penalty = [];
    obj.marks.forEach((mark) => {
      const issetMark = this.marks.find((markItem) => markItem.time === mark.time);
      if (!issetMark) {
        this.marks.push(new Mark(mark));
      } else {
        issetMark.update(mark);
      }
    });
    if (obj.penalty) {
      obj.penalty.forEach((penal) => {
        const issetPanelty = this.penalty.find((penaltyItem) => penaltyItem.time === new Date(penal.time));
        if (!issetPanelty) {
          this.penalty.push(new Penalty(penal));
        } else {
          issetPanelty.update(penal);
        }
      });
    }

    this.timeFromStart = obj.timeFromStart;
    this.penaltyTime = obj.penaltyTime;
    this.time = obj.time;
    this.name = obj.name;
    this.deltaLeader = obj.deltaLeader;
  }
}
